import {
	IAuthConnectRequestPayload,
	IAuthConnectResponsePayload,
	ITokenResponsePayload,
	IAuthRefreshTokenRequestPayload,
} from 'redux/reducers/auth/types';
import { endpoint } from 'services/endpoint';
import { http, httpRefresh } from 'services/http';
import { TAuthApi } from './types';

// ==========================================:
export const auth: TAuthApi = {
	refreshToken: (payload) =>
		httpRefresh
			.post<
				IAuthRefreshTokenRequestPayload,
				{ data: ITokenResponsePayload }
			>(endpoint.auth.REFRESH_TOKEN, payload)
			.then((response) => response.data),

	logout: (payload) => http.post(endpoint.auth.LOGOUT, payload),
	connect: (payload) =>
		http
			.post<
				IAuthConnectRequestPayload,
				{ data: IAuthConnectResponsePayload }
			>(endpoint.auth.CONNECT, payload)
			.then((response) => response.data),
};
